import "./Login.scss";

import { useMsal } from "@azure/msal-react";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import Alert from "ui/build/components/Alert/Alert";
import Button from "ui/build/components/Button/Button";
import Heading from "ui/build/components/Heading/Heading";
import Input from "ui/build/components/Inputs/Input";
import Loader from "ui/build/components/Loader/Loader";

import fetchEnv from "../../utils/FetchEnv";
import { loginRequest } from "../../utils/MSLoginConfig";
import PasswordIcon from "../../utils/PasswordIcon";
import { t } from "../../utils/ResourceUtils";
import useFetch from "../../utils/useFetch";
import { handleLoginOnSuccess } from "./Login.utils";
import PasswordResetModal, { ResetPasswordModel } from "./PasswordResetModal";
import RegisterModal from "./RegisterModal";

const initialState = {
  username: "",
  email: "",
  password: "",
  termsNCondition: false,
};

const securityData = {
  email: "",
  securityAnswer1: "",
  securityAnswer2: "",
  securityAnswer3: "",
};

export const handleVerifyResText = ({ setIsResetPasswordModalOpen, setShowAlert, setAlert, errorText }) => {
  setIsResetPasswordModalOpen(false);

  setShowAlert(true);
  setAlert({
    alertType: "danger",
    message: errorText,
  });
};

function Login({ tenant, product, enableSingleSignOn = true }) {
  const [isRegModalOpen, setIsRegModalOpen] = useState(false);
  const [isResetPasswordModalOpen, setIsResetPasswordModalOpen] = useState(false);
  const [openNewPasswordModel, setOpenNewPasswordModal] = useState(false);
  const [loginReqData, setLoginReqData] = useState(initialState);
  const [passwordData, setPasswordData] = useState(securityData);
  const [flag, setFlag] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [redirectUrl, setRedirectUrl] = useState("/");
  const { executeFetch } = useFetch(`${fetchEnv()?.REACT_APP_APIURL_ADMIN}`);
  const [isSSOLoading, setIsSSOLoading] = useState(false);

  const [showAlert, setShowAlert] = useState(false);
  const [alert, setAlert] = useState({
    alertType: "",
    message: "",
  });

  const [isLoading, setIsLoading] = useState(false);
  const [isErrorsVisible, setIsErrorsVisible] = useState(false);
  const isLoginValid = loginReqData.password && loginReqData.email;

  const { instance } = useMsal();

  const onLoginReqDataChange = (e) => {
    setLoginReqData({
      ...loginReqData,
      [e.target.name]: e.target.value,
    });
    setErrorMessage(null);
  };

  const handleLogin = async (event) => {
    event.preventDefault();
    if (!isLoginValid) return setIsErrorsVisible(true);
    setIsLoading(true);
    await executeFetch({
      api: "authservice/v1/",
      options: {
        method: "POST",
        headers: {
          ...loginReqData,
          // tenantID: tenant ?? "datafoundry",
          product: product ?? "msafety",
          "Accept-Language": "en",
          "Content-Type": "application/json",
          "Ocp-Apim-Subscription-Key": fetchEnv()?.REACT_APP_AUTH_SUBSCRIPTION_KEY,
        },
      },
      onSuccess: (response) =>
        handleLoginOnSuccess({
          response,
          setRedirectUrl,
          setFlag,
          setErrorMessage,
          setIsLoading,
          setIsErrorsVisible,
          product,
        }),
      onError: () => setIsLoading(false),
    });
  };

  const handleSSOLogin = async () => {
    try {
      setIsSSOLoading(true);
      const msLoginResponse = await instance?.loginPopup(loginRequest);
      const id_token = msLoginResponse?.idToken;
      localStorage.setItem("isSSOUser", true);
      await executeFetch({
        api: "authservice/v1/ssoSwitchContext/microsoftonline_ad/product/msafety",
        options: {
          method: "GET",
          headers: {
            product: product ?? "msafety",
            "Accept-Language": "en",
            "Content-Type": "application/json",
            "Ocp-Apim-Subscription-Key": fetchEnv()?.REACT_APP_AUTH_SUBSCRIPTION_KEY,
            Authorization: id_token,
          },
        },
        onSuccess: (response) =>
          handleLoginOnSuccess({
            response,
            setRedirectUrl,
            setFlag,
            setErrorMessage,
            setIsLoading: setIsSSOLoading,
            setIsErrorsVisible,
            product,
          }),
        onError: () => setIsSSOLoading(false),
      });
    } catch (error) {
      setIsSSOLoading(false);
      setIsErrorsVisible(true);
      setErrorMessage("Something went wrong. Please try again.");
    }
  };

  const [textConfig, setTextConfig] = useState({
    variant: "outlined",
    name: "password",
    type: "password",
    placeholder: t("cm.enter_password"),
    label: t("cm.password"),
  });

  const handleClick = (config) => {
    if (config.type === "password") {
      setTextConfig({
        ...textConfig,
        type: "text",
      });
    } else {
      setTextConfig({
        ...textConfig,
        type: "password",
      });
    }
  };

  const handleReg = () => {
    setIsRegModalOpen(true);
  };

  const handlePass = (open) => {
    setIsResetPasswordModalOpen(open);
  };

  const handleRegisterModal = (isOpen) => {
    setIsRegModalOpen(isOpen);
  };

  const handleVerifyClick = (data, errorText) => {
    if (errorText) {
      handleVerifyResText({ setIsResetPasswordModalOpen, setShowAlert, setAlert, errorText });
    } else {
      setPasswordData(data);
      setIsResetPasswordModalOpen(false);
      setOpenNewPasswordModal(true);
    }
  };

  const handleNewPasswordReset = (errorText) => {
    if (errorText) {
      setShowAlert(true);
      setAlert({
        alertType: "danger",
        message: errorText,
      });
    }
    setOpenNewPasswordModal(false);
    setPasswordData({});
  };

  return (
    <>
      {showAlert ? (
        <Alert
          alertType={alert.alertType}
          show={showAlert}
          dismiss={true}
          onClose={() => {
            setShowAlert(!showAlert);
          }}
        >
          {alert.message}
        </Alert>
      ) : null}

      {flag ? (
        window.location.replace(redirectUrl)
      ) : (
        <div className="df-login-container">
          <div className="left-half">
            <Heading variant="h2" className="text-center">
              <img src={`/assets/DF mSafety AI.png`} alt={"mSafety logo"} style={{ height: "60px" }}></img>
            </Heading>
            <h4 className="logo-text">{t("cm.please_login_to_your_account")}</h4>
            <form onSubmit={handleLogin}>
              <div className="df-login-left-bottom">
                <div style={{ width: "343px" }}>
                  <div className=" d-flex justify-content-center">
                    <div className="df-error-section">
                      {isErrorsVisible && errorMessage && <div className="df-error-message">{errorMessage}</div>}
                    </div>
                  </div>
                  <div className="mt-3 d-flex justify-content-center">
                    <Input
                      style={{ width: "343px" }}
                      variant="outlined"
                      type="email"
                      name="email"
                      label={t("cm.enter_email")}
                      placeholder={t("cm.enter_email")}
                      autoFocus
                      value={loginReqData?.email}
                      onChange={(e) => onLoginReqDataChange(e)}
                      autoComplete="off"
                    />
                  </div>
                  {isErrorsVisible && !loginReqData?.email && (
                    <div className="required-text">{t("cm.email_is_required")}</div>
                  )}

                  <div className="mt-4 d-flex justify-content-center">
                    <Input value={loginReqData?.password} {...textConfig} onChange={(e) => onLoginReqDataChange(e)}>
                      <PasswordIcon textConfig={textConfig} onClick={handleClick} />
                    </Input>
                  </div>
                  {isErrorsVisible && !loginReqData?.password && (
                    <div className="required-text">{t("cm.password_is_required")}</div>
                  )}

                  {isLoading ? (
                    <Button disabled type="submit">
                      {t("cm.signing_in")}
                      <Loader variant="primary" />
                    </Button>
                  ) : (
                    <Button type="submit">{t("cm.sign_in")}</Button>
                  )}

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Link to="/#" style={{ padding: "10px 30px 5px 0px" }} onClick={handleReg}>
                      <span>{t("cm.register")}</span>
                    </Link>
                    <Link to="/#" style={{ padding: "10px 0px 5px 20px" }} onClick={() => handlePass(true)}>
                      <span>{t("cm.reset_password")}</span>
                    </Link>
                  </div>

                  {enableSingleSignOn ? (
                    <div className="SSO-Container" style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                      {/* seperator */}
                      <div className="Login-Seperator">
                        <div className="Login-Seperator-Line"></div>
                        <span>{t("cm.or")}</span>
                        <div className="Login-Seperator-Line"></div>
                      </div>

                      {isSSOLoading ? (
                        <Button disabled>
                          {t("cm.signing_in")}
                          <Loader variant="primary" />
                        </Button>
                      ) : (
                        <Button onClick={handleSSOLogin}>{t("cm.sso")}</Button>
                      )}
                    </div>
                  ) : null}
                </div>
              </div>
            </form>
          </div>

          <img
            src={"/assets/mSafety_Banners.png"}
            className="img-fluid"
            style={{ height: "420px" }}
            alt="mSafety Banner"
          />
        </div>
      )}

      {isRegModalOpen && <RegisterModal open={isRegModalOpen} handleRegisterModal={handleRegisterModal} />}
      {isResetPasswordModalOpen && (
        <PasswordResetModal
          open={isResetPasswordModalOpen}
          handlePasswordResetModal={handlePass}
          handleVerifyClick={handleVerifyClick}
        />
      )}
      {openNewPasswordModel && (
        <ResetPasswordModel
          open={openNewPasswordModel}
          data={passwordData}
          handleNewPasswordReset={handleNewPasswordReset}
        />
      )}
    </>
  );
}

export default Login;
